import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { activityDate2Human } from '../../utils/dateTime';
import Form, { FormInput } from '../common/Form';
//
// Компонент выводит список дат мероприятия для формирования ссылки пресета
//
const PresetDates = ({ event, dates, setDates }) => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language === 'en' ? 'en' : 'ru';
	const list = event.dates ?? [];

    const onChange = (date) => {
        const d = date.split(' ')[0];
        const index = dates.indexOf(d);
        let newDates = [...dates];
        if(index < 0) {
            newDates.push(d);
        } else {
            newDates.splice(index, 1);
        }
        setDates(newDates);
    };

    if(!list.length) return null;

	return (
    <Form>
        <fieldset>
        <legend>{t('preset.dates')}</legend>
        {[...list].sort().map((item, index) => (
            <FormInput
                id={`date-${index}`}
                key={index}
                type='checkbox'
                value={dates.includes(item.split(' ')[0]) ? item : ''}
                label={activityDate2Human(item, lang, false)}
                onChange={() => onChange(item)}
            />
        ))}
        </fieldset>
    </Form> 
	);
};

PresetDates.propTypes = {
    event: PropTypes.object.isRequired,
    dates: PropTypes.arrayOf(PropTypes.string).isRequired,
    setDates: PropTypes.func.isRequired,
};

export default PresetDates;
